import { render, staticRenderFns } from "./CambioEstadoMasivo.vue?vue&type=template&id=19d2285e"
import script from "./CambioEstadoMasivo.vue?vue&type=script&lang=js"
export * from "./CambioEstadoMasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports